import { Empty, Modal } from 'antd';
import moment from 'moment';
import React from 'react';
import { onSubmit } from './../actions/ordersAction';
import { onSubmit as onSubmitShipment } from './../actions/shipmentAction';
import { getHeaderSummary } from './../actions/headerAction';
import lang from './../languages/en';
import store from './../store';
import { alertError, alertWarning } from './dialog';
import { convertDateToUTC } from './dst';
import { fullSize } from './ruleValidate';
import { imageEmpty } from './base64'

// trim input
export const trimData = (value) => {
    if (typeof value === 'string') {
        return value.trim()
    }
    return value
}

// check full size compare half size where enter input
export const CheckFullSizeHalfSize = (value, maxlength) => {
    let fullSizeArr = []
    let halfSizeArr = []

    if (!maxlength) return true;

    if (value && typeof value === 'string') {
        let arrayValue = value.split('')
        for (let i = 0; i < arrayValue.length; i++) {
            if (fullSize(arrayValue[i])) {
                fullSizeArr.push(arrayValue[i])
            } else {
                halfSizeArr.push(arrayValue[i])
            }
        }
    }
    if (2 * fullSizeArr.length + halfSizeArr.length <= maxlength) {
        return true
    } else {
        return false
    }
}

// clear console
export const clearConsole = () => {
    if (window.location.host !== 'localhost:3000') {
        window.console = () => { };
    }
}

export const getShipmentParams = (state, notChecked) => {
    let startToday = moment().format('MM/DD/YYYY') + ' 00:00:00'
    let endToday = moment().format('MM/DD/YYYY') + ' 23:59:59'

    return {
        Status: state.shipmentReducer.input_filter.status_list,
        FulfillmentOption: state.shipmentReducer.fulfillment_option,
        Type: state.shipmentReducer.input_filter.type_list,
        OrderDateFrom: convertDateToUTC(new Date(state.shipmentReducer.input_filter.order_date_from + ' 00:00:00')),
        OrderDateTo: convertDateToUTC(new Date(state.shipmentReducer.input_filter.order_date_to + ' 23:59:59')),
        ShippingDateFrom: convertDateToUTC(new Date(state.shipmentReducer.input_filter.shipping_date_from + ' 00:00:00')),
        ShippingDateTo: convertDateToUTC(new Date(state.shipmentReducer.input_filter.shipping_date_to + ' 23:59:59')),
        StartToday: convertDateToUTC(new Date(startToday)),
        EndToday: convertDateToUTC(new Date(endToday)),
        TrackingNumberFrom: state.shipmentReducer.input_filter.tracking_number_from,
        TrackingNumberTo: state.shipmentReducer.input_filter.tracking_number_to,
        OrderBy: state.shipmentReducer.orderBy,
        IsDesc: state.shipmentReducer.isDesc,
        PageSize: state.shipmentReducer.offset,
        Page: state.shipmentReducer.current_page,
        ChannelOrderID: state.shipmentReducer.input_filter.channel_order_no,
        ChannelID: state.shipmentReducer.input_filter.channel,
        SelectedIds: !notChecked ? state.shipmentReducer.listIdCheckedShipments : [],
    }
}

export const getOrderParams = (state, notChecked) => {
    return {
        Status: state.ordersReducer.input_filter.status_list,
        FulfillOption: state.ordersReducer.input_filter.fulfill_option,
        Type: state.ordersReducer.input_filter.type_list,
        OrderDateFrom: convertDateToUTC(new Date(state.ordersReducer.input_filter.from + ' 00:00:00')),
        OrderDateTo: convertDateToUTC(new Date(state.ordersReducer.input_filter.to + ' 23:59:59')),
        OrderBy: state.ordersReducer.orderBy,
        IsDesc: state.ordersReducer.isDesc,
        PageSize: state.ordersReducer.offset,
        Page: state.ordersReducer.current_page,
        ChannelOrderID: state.ordersReducer.input_filter.channel_order_no,
        ChannelID: state.ordersReducer.input_filter.channel,
        SelectedIds: !notChecked ? state.ordersReducer.listIdCheckedOrders : [],
    }
}

export const renderListShipment = (notChecked = true, params = {}) => {
    let stateInStore = getShipmentParams(store.getState(), notChecked)
    store.dispatch(onSubmitShipment({ ...stateInStore, ...params, isKeepState: true }))
}

export const renderListOrder = () => {
    let stateInStore = getOrderParams(store.getState(), 'notChecked')
    store.dispatch(onSubmit({ ...stateInStore, isKeepState: true }))
}

export const renderHeaderSummary = () => {
    store.dispatch(getHeaderSummary())
}

export const getIEVersion = () => {
    var sAgent = window.navigator.userAgent;
    var Idx = sAgent.indexOf("MSIE");

    // If IE, return version number.
    if (Idx > 0)
        return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));

    // If IE 11 then look for Updated user agent string.
    else if (!!navigator.userAgent.match(/Trident\/7\./))
        return 11;

    else
        return 0; //It is not IE
}

export const splitMessage = (message, type) => {
    let arraySplit = message.split('.')
    if (type === 3) {
        alertError(arraySplit[0] + '.', arraySplit[1] + '. ' + arraySplit[2] + '.')
    } else {
        alertError(arraySplit[0] + '.', arraySplit[1] + '.')
    }
}

export const splitMessageWarring = (message, type) => {
    let arraySplit = message.split('.')
    if (type === 3) {
        alertWarning(arraySplit[0] + '.', arraySplit[1] + '. ' + arraySplit[2] + '.')
    } else {
        alertWarning(arraySplit[0] + '.', arraySplit[1] + '.')
    }
}

export const showWaringTransmitNotCompleted = (message, ok, cancel, okText) => {
    Modal.warning({
        width: 700,
        title: lang.transmit_shipment_not_completed,
        content: (
            <div>
                <p>{message}</p>
            </div>
        ),
        onOk() {
            ok ? ok() : null
        },
        onCancel() {
            cancel ? cancel() : null
        },
        okText,
        autoFocusButton: null
    });
}

export const handlePrintPreview = (data) => {
    const file = new Blob(
        [data],
        { type: 'application/pdf' });

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        if (getIEVersion() > 1) {
            window.navigator.msSaveOrOpenBlob(file);
        } else {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.href = window.URL.createObjectURL(file);
            a.download = Date.now() + '.pdf'
            a.click()
        }
    } else {
        const fileURL = URL.createObjectURL(file);
        let newWin = window.open(fileURL, '_blank');

        if (!newWin || newWin.closed || typeof newWin.closed == 'undefined') {
            alertWarning(lang.print_popup_block, lang.print_popup_block_line2)
        }
    }
}

export const detectAdBlocker = () => {
    if (document.getElementById('wrapfabtest').clientHeight > 0) {
        return false
    } else {
        alertWarning(lang.detect_ad_blocker, lang.detect_ad_blocker_line2);
        return true;
    }
}

export const detectPopupBlocker = (data) => {
    const file = new Blob(
        [null],
        { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    let newWin = window.open(fileURL, '_blank');
    if (!newWin || newWin.closed || typeof newWin.closed == 'undefined') {
        alertWarning(lang.print_popup_block, lang.print_popup_block_line2)
        return true;
    } else {
        return false
    }
}

export const clearCache = () => {
    caches.keys().then(function (keys) {
        var promises = [];
        keys.forEach(function (cacheName) {
            if (cacheName) {
                promises.push(caches.delete(cacheName));
            }
        });
    });
}

export const checkIsChildArr = (parentArr, childArr) => {
    if (!parentArr || !parentArr.length) {
        return false;
    }
    let isChild = true
    childArr.forEach((elm, idx) => {
        if (parentArr.indexOf(elm) === -1) {
            isChild = false
        }
    })
    return isChild
}

export const doPaging = (current, { range, pages, start = 1 }) => {
    const paging = []
    var i = Math.min(pages + start - range, Math.max(start, current - ((range / 2) | 0)))
    const end = i + range
    while (i < end) {
        paging.push(i++)
    }
    pages = paging.filter(a => a > 0)
    return pages
}

export const setHeight = (minHeight = 590) => {
    // Set the same height for three column
    let settingLeft = document.getElementById('setting-left')
    let settingCenter = document.getElementById('setting-center')
    let settingRight = document.getElementById('setting-right')

    // Reset when resize window
    if (settingLeft) {
        settingLeft.setAttribute("style", "height: auto");
    }
    if (settingCenter) {
        settingCenter.setAttribute("style", "height: auto");
    }
    if (settingRight) {
        settingRight.setAttribute("style", "height: auto");
    }

    let contentHeight = window.innerHeight - 67
    let leftHeight = settingLeft ? settingLeft.clientHeight : contentHeight
    let centerHeight = settingCenter ? settingCenter.clientHeight : contentHeight
    let rightHeight = settingRight ? settingRight.clientHeight : contentHeight

    let maxHeight = Math.max(
        leftHeight,
        centerHeight,
        rightHeight,
        contentHeight,
        minHeight
    )
    if (settingLeft) {
        settingLeft.setAttribute("style", "height:" + maxHeight + "px");
    }
    if (settingCenter) {
        settingCenter.setAttribute("style", "height:" + maxHeight + "px");
    }
    if (settingRight) {
        settingRight.setAttribute("style", "height:" + maxHeight + "px");
    }
};

export const copyData = (input) => {
    return JSON.parse(JSON.stringify(input))
}

export const titleHead = (title) => {
    return document.title = title + ' - Y-Ship';
}

export const iconEmpty = (description) => {
    if (typeof description === 'undefined' || !description) {
        description = 'No data';
    }
    return (
        <div className='icon-custom-empty'>
            <Empty
                description={description}
                image={imageEmpty}
            />
        </div>
    )
}

export const dateTimeCurrent = () => {
    return moment().format("MMDDYYYYHHmmss")
}

/**
 * ant multi select max tag count, render text custom and title full
 * @param array values
 * @param object values format {ID, Name}
 * @return object format {id: value}
 */
export const renderSelectAntTitle = (values, objMap) => {
    let objConvert = {};
    objMap.map((item) => {
        objConvert[item.ID] = item.Name;
    });
    let title = '';
    values.forEach((i) => {
        if (objConvert[i]) {
            title += objConvert[i] + ', ';
        }
    });
    title = title.slice(0, -2);
    return <span title={title}>{"+" + values.length + "..."}</span>;
}

/**
 * get first value in array values, compare objectMap
 * @param array values [ID]
 * @param object values format {ID, Name}
 * @return string Name...
 */
export const getFirstValueObj = (values, objMap) => {
    let title = '';
    if (!values || !values.length || typeof objMap !== 'object') {
        return title;
    }
    objMap.some((item) => {
        if (item.ID === parseInt(values[0], 10)) {
            title = item.Name;
            return true;
        }
    });
    if (title) {
        if (values.length > 1) {
            title += ' ...'
        }

    }
    return title;
}

/**
 * scroll dom to position
 *
 * @param float top
 * @param float left
 */
export const scrollToPos = (dom, top = 0, left = 0) => {
    try {
        dom.scrollTop = top;
        dom.scrollLeft = left;
        dom.scrollTo(top, left);
    } catch (err) {}
}

/**
 * parse url from a string => object full information
 */
export const parseUrlFromString = (url) => {
    if (!url) {
        return null;
    }
    var match = url.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
    if (!match) {
        return null;
    }
    var result = {
        href: url,
        protocol: match[1],
        host: match[2],
        hostname: match[3],
        port: match[4],
        pathname: match[5],
        search: match[6],
        hash: match[7],
        domain: null,
    };
    if (!result.hostname) {
        return result;
    }
    var matchSubdomain = result.hostname.match(/\./g);
    if (!matchSubdomain || matchSubdomain.length < 2) {
        return result;
    }
    if (!isNaN(result.hostname.substr(0, result.hostname.indexOf('.')))) {
        //result.domain = result.hostname;
        return result;
    }
    result.domain = result.hostname.substr(result.hostname.indexOf('.')+1);
    return result;
}


// WEBPACK FOOTER //
// ./src/services/helper.js